const forgotPasswordActivate = {
  toastr: 'Contraseña cambiada',
  toastr1: 'La contraseña fue cambiada con éxito'
};

export default forgotPasswordActivate;
